import { useParams } from 'react-router-dom';

import { decodeFlowCode } from '../flow/flowLink';
import { ChatWidget } from '../flow/ChatWidget';
import { FlowRunner } from '../flow/FlowRunner';
import { EmptySession } from '../ui/EmptySession';

/**
 * The shareable applicant entry, `/u/<code>` — the link partners send. The code
 * decodes to the case-bound applicant token (`flow/flowLink.ts`), and from there
 * it is the same desktop entry as `/verify?token=`: open the session and offer
 * the QR handoff to a phone. A code that does not decode is a broken link, not
 * a verification failure, so it gets the soft empty state.
 */
export function FlowLinkScreen() {
  const { code } = useParams<{ code: string }>();
  const token = code ? decodeFlowCode(code.trim()) : null;

  if (!token) {
    return <EmptySession kind="missing" />;
  }

  return (
    <>
      <FlowRunner token={token} withHandoff />
      <ChatWidget token={token} />
    </>
  );
}
